<template>
  <v-card :style="backOpacity">
    <v-card-title>入力無効化フォーム AllDisabledForm.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          見た目は無いが一部を除いた全ての要素を無効化する機能を付与
          <v-col cols="6">
            <v-text-field
              label="ラベル名(使わない)"
              v-model="returnData.label"
              :rules="[varidation.required]"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <!-------------- ------------>
        <div v-for="(term, i) in joinTerms" :key="`1-${i}`" class="mb-4">
          <v-row>
            <v-col cols="2">
              <div v-if="i != 0">
                <v-select
                  :items="joinTerm"
                  v-model="joinTerms[i]"
                  label="AND OR"
                  :rules="[varidation.required]"
                ></v-select>
              </div>
            </v-col>
            <v-col cols="3">
              <v-select
                :items="selectclickTerms"
                v-model="clickTerms[i]"
                label="条件"
                item-text="label"
                item-value="value"
                :rules="[]"
              ></v-select>
            </v-col>
            <v-col cols="2" v-if="clickTerms[i] == 'role'">
              <v-select
                label="権限レベル"
                :rules="[]"
                v-model="clickTermValues[i]"
                item-text="label"
                item-value="value"
                :items="selectRole"
              ></v-select>
            </v-col>
            <v-col
              cols="2"
              v-else-if="
                clickTerms[i] == 'formID' ||
                  clickTerms[i] == 'UserformID' ||
                  clickTerms[i] == 'formIDisNotNull'
              "
            >
              <v-text-field
                label="条件対象formID"
                :rules="[varidation.numonly]"
                v-model="clickTermValues[i]"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="2"
              v-else-if="
                clickTerms[i] == 'uuID' ||
                  clickTerms[i] == 'name' ||
                  clickTerms[i] == 'email'
              "
            >
              <v-text-field
                label="条件対象formID"
                :rules="[varidation.numOrEx]"
                v-model="clickTermValues[i]"
                hint="先頭に「!」を付けると条件式が!=になります。"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="3"
              v-if="clickTerms[i] == 'formID' || clickTerms[i] == 'UserformID'"
            >
              <v-text-field
                label="if == X"
                :rules="[]"
                v-model="clickTermCondition[i]"
                required
              ></v-text-field>
              *{}で囲むとX文字列を含む場合
            </v-col>
          </v-row>
        </div>
        <!-------------------------------------->
        <hr />
        <v-row>
          <v-col cols="6">
            <v-text-field
              label="条件対象外のformID(.区切り)"
              :rules="[varidation.numANDten]"
              v-model="rules[5]"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <!-------------------------------------->
        <v-row>
          <v-col cols="1">
            <v-btn @click="add1" class="ma-2">追加</v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn @click="del1" class="ma-2">削除</v-btn>
          </v-col></v-row
        >
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        x-large
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    label: String,
    type: Number,
    cols: Number,
    position: Number,
    //個別値
    value: String,
    rule: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        type: this.type,
        cols: this.cols,
        position: this.position,
        //個別値
        value: this.value,
        rule: this.rule,
      },
      backOpacity: "opacity: 1",
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        numOrEx: (value) => {
          return /^!?[0-9]*$/.test(value) || "!数値, 数値 のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        numANDten: (value) => {
          return /^[0-9.]*$/.test(value) || "数値と.のみ";
        },
        required: (value) => !!value || "必須項目です",
      },
      //個別値
      rules: [],
      joinTerms: ["OR"],
      clickTerms: ["role"],
      clickTermValues: ["0"],
      clickTermCondition: ["状態A"],
      //
      joinTerm: ["AND", "OR", "AND(", "OR(", "AND)", "OR)"],
      selectclickTerms: [
        { label: "ユーザ権限", value: "role" },
        { label: "特定フォーム値", value: "formID" },
        { label: "特定フォーム値が空ではない時", value: "formIDisNotNull" },
        { label: "ユーザ情報の特定フォーム値", value: "UserformID" },
        { label: "自身のuuIDと比較", value: "uuID" },
        { label: "自身の名前と比較", value: "name" },
        //back側も出来てるがプライベートな情報のため消している { label: "自身のメールアドレスと比較", value: "email" },
      ],
      selectRole: [
        { label: "一般", value: "0" },
        { label: "管理者", value: "1" },
        { label: "第3属性", value: "2" },
      ],
    };
  },
  mounted() {
    if (this.rule != "" || typeof this.rule == "undefined") {
      this.rules = this.rule.split(",");
    }
    if (this.rules.length > 3) {
      this.joinTerms = this.rules[1].split(":");
      this.clickTerms = this.rules[2].split(":");
      this.clickTermValues = this.rules[3].split(":");
      this.clickTermCondition = this.rules[4].split(":");
    }
  },
  methods: {
    submit() {
      this.rules[1] = this.joinTerms.join(":");
      this.rules[2] = this.clickTerms.join(":");
      this.rules[3] = this.clickTermValues.join(":");
      this.rules[4] = this.clickTermCondition.join(":");

      this.returnData.rule = this.rules.join(",");
      //
      this.$emit("clickSubmit", this.returnData);
    },
    add1() {
      let i = this.joinTerms.length - 1;
      this.joinTerms.push(this.joinTerms[i]);
      this.clickTerms.push(this.clickTerms[i]);
      this.clickTermValues.push(this.clickTermValues[i]);
      this.clickTermCondition.push(this.clickTermCondition[i]);
    },
    del1() {
      if (this.joinTerms.length > 0) {
        this.joinTerms.splice(-1, 1);
        this.clickTerms.splice(-1, 1);
        this.clickTermValues.splice(-1, 1);
        this.clickTermCondition.splice(-1, 1);
      }
    },
  },
};
</script>
